import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import loadableVisibility from 'react-loadable-visibility/loadable-components'
import {
  backdrop,
  wrapper,
  previewCardContainer,
  WpBlogHomeContainer,
} from './index.module.css'
import MainBlackHeader from '../MainBlackHeader'
import WpPrimaryBlogPostPreview from '../WpPrimaryBlogPostPreview'
import SEO from '../SEO'

const WpBlogHomeTags = loadableVisibility(() => import('../WpBlogHomeTags'), {
  fallback: <></>,
})

const WpBlogPostPreview = loadableVisibility(
  () => import('../WpBlogPostPreview'),
  {
    fallback: <></>,
  }
)

const WpBlogHomeBanner = loadableVisibility(
  () => import('../WpBlogHomeBanner'),
  {
    fallback: <></>,
  }
)

const WpBlogHome = ({ data, defaultdata, tags, location, featuredPost }) => {
  const intl = useIntl()
  const blogTitle = intl.formatMessage({ id: 'blog.title' })
  const homeUrl = intl.formatMessage({ id: 'blog.homeUrl' })
  const [posts, setPosts] = useState(data)
  const [active, setActive] = useState(false)
  const [tagArray, setTagArray] = useState([])

  const containsAll = (items, array) =>
    items.every(Set.prototype.has, new Set(array))

  const handleClick = (tag) => {
    setActive(!active)
    if (tag === 'allTags' || tagArray.length === 0) {
      setPosts(data)
    } else {
      setPosts(data.filter(({ node }) => containsAll(tagArray, node.t)))
    }
  }

  return (
    <div className={WpBlogHomeContainer}>
      <SEO type="blogHome" slug={homeUrl} {...data} />
      <MainBlackHeader title={blogTitle} ctaUrl={homeUrl} linkh1={true} />
      <div className={backdrop}>
        <div className={wrapper}>
          <div>
            <WpPrimaryBlogPostPreview
              data={featuredPost}
              defaultdata={defaultdata}
              primary={true}
              location={location}
            />
          </div>
          {tags.length > 0 && (
            <WpBlogHomeTags
              tags={tags.sort((a, b) => b.node.count - a.node.count)}
              active={active}
              setTagArray={setTagArray}
              tagArray={tagArray}
              handleClick={handleClick}
              location={location}
            />
          )}

          <div className={previewCardContainer}>
            {posts.map(({ node }, idx) => {
              if (idx === 8) {
                return (
                  <>
                    <WpBlogPostPreview
                      data={node}
                      defaultdata={defaultdata}
                      key={idx}
                      location={location}
                    />
                    <WpBlogHomeBanner key={idx} />
                  </>
                )
              }
              return (
                <WpBlogPostPreview
                  data={node}
                  defaultdata={defaultdata}
                  key={idx}
                  location={location}
                />
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default WpBlogHome
